<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="detailTitle">单笔付款明细</div>
                <div class="header_row_return" @click="backList">
                    返回列表
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked">删除</el-button>
            </div> -->
            <div class="tableBox">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" @getTableEdit="getTableEdit" @getTableDelete="getTableDelete" :tabledata="list" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">付款金额： {{totalObj.amount}}</div>
                <div class="totalNumber">¥实付金额：{{totalObj.payment}}</div>
                <!-- <div class="totalNumber">优惠/赔偿金: {{totalObj.paid}}</div> -->
                <div class="totalNumber">结算金额: {{totalObj.settlement}}</div>
                <div class="totalNumber">采购余额: {{totalObj.balance}}</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 新增付款单 dialog START -->
        <el-dialog v-dialog-drag title="付款单" :visible.sync="addDialogVisibleBack" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
            <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                <div class="eldialogFormBox">
                    <!-- <el-form-item label="退货单号：">
                        <el-input v-model="add_params.order_sn" disabled></el-input>
                    </el-form-item> -->
                    <el-form-item label="交易日期：">
                        <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="我方账户：">
                        <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                            <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                        <!-- <el-input v-model="add_params.account_name"></el-input> -->
                    </el-form-item>
                    <el-form-item label="供应商名称：">
                        <el-select v-model="add_params.supplier_id" placeholder="" filterable disabled @visible-change="getSelectList('supplier')">
                            <el-option v-for="item in selectMap.supplier" :key="'add_form_customer_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="流水类型：">
                        <el-select v-model="add_params.bill_type" disabled placeholder="" >
                            <el-option :value="0"  label="收入"></el-option>
                            <el-option :value="1"  label="支出"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="交易方式：">
                        <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                            <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目名称：">
                        <el-input v-model="add_params.course_title" disabled placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="交易RMB金额：">
                        <el-input v-model="add_params.amount" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item label="发票：">
                        <el-select v-model="add_params.is_invoice" placeholder="" >
                            <el-option :value="0"  label="未开"></el-option>
                            <el-option :value="1"  label="已开"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <el-input v-model="add_params.remark" placeholder=""></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div class="dialogBtnList clearfix">
                <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBack=!addDialogVisibleBack">取消</el-button>
                <el-button  class="publicBtn dialogBtn" @click="addOrderSheetBack">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增收款单 dialog END -->
    </div>
</template>
<style scoped>
    .header_row_return{float: right;font-size: 14px;font-weight: 600;}
    .search_box{padding-right:10px;}
    .search_box{padding-bottom:10px;}
    .detailTitle{float: left;line-height: 33px;}
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                id:"",
                params:{
                    id:"",
                    per_page: 50,
                    page:1
                },
                bill:{},
                trading_time:"",
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[],
                    supplier:[]
                },
                last_page: 1,
                current_page: 1,
                total: 0,
                list : [],
                add_params : {
                    order_id : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                addDialogVisible:false,
                sureDialogVisible:false,
                addDialogVisibleBack:false,
                trading_time : new Date(),
                add_params : {
                    id:"",
                    trading_time:"",
                    account_name:"",
                    supplier_id:"",
                    payment_type_id:"",
                    bill_type:1,
                    course_title:"采购贷款",
                    amount:"",
                    is_invoice:"",
                    remark:""
                },
                sure_params : {
                    order_id : "",
                    amount : "",
                    remark : ""
                },
                tableCol:[	
                    {colName:"交易日期",colKey:"trading_time",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"科目名称",colKey:"course_title",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"我方账户",colKey:"account_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"供应商名称",colKey:"supplier_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款方式",colKey:"payment_type_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"币种",colKey:"currency_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"付款金额",colKey:"inout_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"汇率",colKey:"currency_rate",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"¥实付金额",colKey:"rmb_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"结算方式",colKey:"settlement_type",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"结算金额",colKey:"settlement_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"优惠赔偿金",colKey:"paid_amount",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"凭证",colKey:"files",colWidth:100,isSetWidth:true,isCanClick:false,isColor:true,isStockImg:true,},
                    {colName:"经办人",colKey:"operator_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                selectRow:[],
                totalObj:{},
                customer_id:"",
                settlement_amount:0
            }
        },
        created(){
            if(sessionStorage.DEMU_ERP_PAYSUMMARY_ID){
                this.id=sessionStorage.DEMU_ERP_PAYSUMMARY_ID;
                this.params.id=sessionStorage.DEMU_ERP_PAYSUMMARY_ID;
                sessionStorage.removeItem("DEMU_ERP_PAYSUMMARY_ID")
            }
            this.getSelectList("user")
            this.getSelectList("customer")
            this.getSelectList("account")
            this.getSelectList("paymentType")
            this.getSelectList("supplier")
            this.getList();
        },
        methods:{
            //添加付款单
            addOrderSheetBack(){
                this.$confirm('是否确认修改付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time/1000)
                    this.postFuncLoading("/erp/cloud.finance.update.payments",this.add_params,()=>{
                        this.tip("修改成功","success")
                        this.addDialogVisibleBack=false;
                        // this.dialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            backList(){
                this.$root.$children[0].$children[0].showTab({
                    label: "应付管理",
                    name: "应付管理",
                    content: "payReceivable",
                });
            },
            getTableDelete(id){
                this.$confirm('是否确认删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/purchase.bill.delete",{id:id},()=>{
                        this.tip("删除成功","success")
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getTableEdit(id){
                this.list.forEach(item=>{
                    if(item.id == id){
                        this.customer_id = item.customer_id;
                        this.postFunc("/erp/finance.bill.view",{id:id},res=>{
                            // this.add_params = res.data.data;
                            this.add_params.id = res.data.data.id;
                            this.add_params.remark = res.data.data.remark;
                            this.trading_time = res.data.data.trading_time;
                            this.add_params.account_name = res.data.data.account_name;
                            this.add_params.account_id = res.data.data.account_id;
                            this.add_params.payment_type_id = res.data.data.payment_type_id;
                            this.add_params.bill_type = res.data.data.bill_type;
                            this.add_params.supplier_id = res.data.data.customer_id;
                            this.add_params.amount = Math.abs(res.data.data.inout_amount);
                            this.add_params.is_invoice = res.data.data.open_invoice;
                            this.trading_time = res.data.data.trading_time*1000;
                            this.addDialogVisibleBack = true;
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.postFunc("/erp/finance.purchase.bills",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.list.data;
                    this.totalObj=res.data.data.statistics;
                    this.totalObj=res.data.data.total;
                    this.list.forEach((item,index)=>{
                        item.isDelete=true;
                        // item.isEdit = true;
                        item.images = item.files;
                        if(item.trading_time!=0){
                            this.list[index].trading_time = this.formatTime(item.trading_time+"000")
                        }
                        if(Number(item.settlement_amount)==0){
                            this.list[index].settlement_amount = "";
                        }else{
                            this.list[index].baseColor = "green";
                        }
                        if(Number(item.inout_amount)==0){
                            this.list[index].inout_amount = "";
                        }else{
                            this.list[index].baseColor = "#FF0000";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow=row;
            },
            resetSearch(){
                this.params={order_id:this.id,per_page: 50,page:1}
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisibleBack":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="采购货款";
                    this.customer_id = "";
                }
            },
            "sureDialogVisible":function(val){
                if(!val){
                    this.sure_params=this.resetJson(this.sure_params)
                    this.customer_id = "";
                }
            },
        }
    }
</script>
